module.exports = __webpack_public_path__ + "static/SUNY-c96b489551300b9ac9d515228b59ec1f.png";